/**
 * サーバーエラーを処理し、適切なメッセージを返す関数
 * @param {Object} error          - エラーオブジェクト
 * @param {Object} customMessages - カスタムメッセージのマップ
 * @returns {string}              - エラーメッセージ
 */
export const handleServerError = (error, customMessages = {}) => {
  // エラーレスポンスのステータスコードを取得
  const status = error.response?.status;

  // デフォルトのエラーメッセージマップ
  const defaultMessages = {
    400: 'Bad Request',
    401: 'Unauthorized',
    403: 'Forbidden',
    404: 'Not Found',
    500: 'Internal Server Error',
  };

  // カスタムメッセージがあればそれを、なければデフォルトのメッセージを返す
  return customMessages[status] || defaultMessages[status] || 'Unknown Error';
};
